import React from 'react'
import { Modal, Button, Form } from 'react-bootstrap'

type Option = {
  value: string
  label: string
}

type ExportRisultatiProps = {
  show: boolean
  onClose: () => void
  exportSimulation: string
  setExportSimulation: (s: string) => void
  exportSessionVR: string
  setExportSessionVR: (s: string) => void
  simulations: Option[]
  sessions: Option[]
  onExport: () => void
}

export const ExportRisultati: React.FC<ExportRisultatiProps> = ({
  show,
  onClose,
  exportSimulation,
  setExportSimulation,
  exportSessionVR,
  setExportSessionVR,
  simulations,
  sessions,
  onExport,
}) => {
  return (
    <Modal show={show} onHide={onClose} centered backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Esporta Risultati</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form.Group className="mb-3">
          <Form.Label>Simulazione</Form.Label>
          <Form.Select
            value={exportSimulation}
            onChange={e => setExportSimulation(e.target.value)}
          >
            <option value="Tutti">TUTTE</option>
            {simulations.map(s => (
              <option key={s.value} value={s.value}>
                {s.label}
              </option>
            ))}
          </Form.Select>
        </Form.Group>

        <Form.Group>
          <Form.Label>Sessione VR</Form.Label>
          <Form.Select
            value={exportSessionVR}
            onChange={e => setExportSessionVR(e.target.value)}
          >
            <option value="Tutti">TUTTE</option>
            {sessions.map(s => (
              <option key={s.value} value={s.value}>
                {s.label}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Annulla
        </Button>
        <Button
          variant="primary"
          onClick={() => {
            onExport()
            onClose()
          }}
        >
          Esporta
        </Button>
      </Modal.Footer>
    </Modal>
  )
}